$(function(){
  // Destroy slider
  if ($(window).width() < 1008 && location.href.includes('/products')) {
  onloadGetProductImgArray();
  }
  var stackEnable = $('.jsc-stackimg-enable').val();
  console.log(stackEnable);
  if (stackEnable == 'false' && $(window).width() >= 1008 && location.href.includes('/products')) {
    onloadGetProductImgArray();
    onloadswapimgclickthumbnailDesk();
  }
  registerSumbit();
  masterPromo(false);
  removeSalesForce();
  cartJsEvent();
  entersearch();
  initbuyitwithflickity();
  onloadswapimgclickthumbnail();
  checkRefParameter();
  beAMember();
});

var $imgContainer = $('.Product__Slideshow');
var $childArrayElement = $imgContainer.find('.Carousel__Cell');
var $navContainer = $('.selectedNav');
var $navCell = $('.navCell');

onloadGetProductImgArray = () =>{
  var $isShow = false;
  var $childArray = $imgContainer.children();
  var $flickityConfig = $imgContainer.attr('data-flickity-config');
  var $obj = JSON.parse($flickityConfig);
  var $selectedColor = $('.ColorSwatch__Radio:checked').val();
  var $navContainer = $('.selectedNav');
  var $navCell = $('.navCell');
  var $producttitle = $('.ProductMeta__Title.Heading.u-h2').attr('data-title');

  setTimeout(function(){
  // Destroy slider
  destroyProductSlider();
  destroyNavSlider();

  $isShow = true;

  initProductSlider($isShow,$obj);
  initNavSlider();
},15);
}

initNavSlider = () =>{
  var $_navCell = $('.navCell');
  var $cellLength = $_navCell.length;
  var $_flickityObj = {prevNextButtons: false,pageDots: false,arrowShape: {x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25},cellAlign: 'center',wrapAround: true}

  if ($(window).width() > 481) {
    if ($cellLength > 6) {
      $('.selectedNav').flickity($_flickityObj);
    }
  } else {
    if ($cellLength > 3) {
      $('.selectedNav').flickity($_flickityObj);
    }
  }
}

initProductSlider = (isShow,obj) =>{
  if (isShow) {
    $imgContainer.flickity(obj);

    // Flickity instance
    var flkty = $imgContainer.data('flickity');
    // elements
    var $cellButtonGroup = $('.selectedNav');
    var $cellButtons = $cellButtonGroup.find('.navCell');

    // update selected cellButtons
    $imgContainer.on( 'select.flickity', function() {
      $cellButtons.filter('.is-selected')
        .removeClass('is-selected');
      $cellButtons.eq( flkty.selectedIndex )
        .addClass('is-selected');
    });

    // select cell on button click
    $cellButtonGroup.on( 'click', '.navCell', function() {
      var index = $(this).index();
      $imgContainer.flickity( 'select', index );
    });
  }
}

destroyProductSlider = () =>{
  $('.Product__Slideshow').flickity();
  $('.Product__Slideshow').flickity('destroy');
}

destroyNavSlider = () =>{
  $('.selectedNav').flickity();
  $('.selectedNav').flickity('destroy');
}

isInt = (evt) =>{
  var $this = $(evt);
  var $val = $this.val();

  var $newVal = $val.replace(/[^0-9]/g,'');

  $this.val($newVal);
}

registerSumbit = () =>{
  $('body').on('click', '#RegisterForm', function() {
    if ($('#jsc-phoneNum').val().length > 9) {
      $('#jsc-phone-error').hide();
      if ($('#jsc-password-reenter').val() == $('#jsc-password').val()) {
        $('#jsc-password-error').hide();
        $(this).submit();
      } else {
        $('#jsc-password-error').show();
        return false;
      }
    }
    else {
      $('#jsc-phone-error').show();
      return false;
    }
  });
}

cartJSAddQuery = (evt, vid, qty, obj, isOpenDrawer, reload) => {
  // Cart js add item, success callback, error callback

  CartJS.addItem(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          console.log('success',location.pathname);
          getThis.element.dispatchEvent(new CustomEvent('product:added', {
            bubbles: isOpenDrawer,
            detail: {
              variant: vid,
              quantity: 1
            }
          }));
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });

  /*jQuery.post('/cart/add.js', {
    items: [
      {
        quantity: parseInt(qty),
        id: parseInt(vid),
        properties: obj
      }
    ]
  })
  .done(function() {
    setTimeout(function(){
      $('.jsc-cart-button').attr("href","/cart");
      if (location.href.includes('/cart')) {
        $('.jsc-check-checkout').val('true');
      }

      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          if (reload == true) {
            location.reload();
          }
          $('.jsc-page-loading').remove();
          $('.jsc-number-icon').text(cart.item_count);
          console.log('success',location.pathname);
          getThis.element.dispatchEvent(new CustomEvent('product:added', {
            bubbles: isOpenDrawer,
            detail: {
              variant: vid,
              quantity: 1
            }
          }));
        }
      });
    },1200);
  })
  .fail(function() {
    console.log( "error" );
  });*/

}

//Start GWP promo
addGWP = (isOpenDrawer) =>{
  $.when($.getJSON('/cart.js', function(cart) {

  })).then(function(cart){
    var $gwpcart_product = {};
    var $ele = $('.jsc-hidden-add-gwp');
    var $promoArray = [];

    // if there are GWP product properties then get the promo number
    for (var i = 0; i < cart.items.length; i++) {
      var $promo = cart.items[i].properties._GWP_Promo;
      if ($promo != undefined) {
        $promoArray.push($promo);
      }
    }

    $ele.each(function() {
      var $vid = parseInt($(this).val());
      var $promoNo = $(this).attr('data-promo');
      var $gwppromoCode = $(this).attr('data-promo-code');
      var $qty = parseInt($(this).attr('data-qty'));
      $gwpcart_product['_GWP_Promo'] = $promoNo;
      $gwpcart_product['_GWP'] = "true";
      $gwpcart_product['_GWP_Promo_Code'] = $gwppromoCode;

      if ($(this).length > 0) {
        if ($promoArray.includes($promoNo)) {
          // if initially is in cart then Update
          cartJSUpdateQuery($vid,$qty,$gwpcart_product, isOpenDrawer);
        } else {
          // if initially not in cart then Add
          cartJSAddQuery(null, $vid, $qty, $gwpcart_product, isOpenDrawer, null);
        }
      }
    });
  });
}

removeGWP = () =>{
  var $ele = $('.jsc-remove-gwp');

  $ele.each(function(){
    var $this = $(this);
    var $key = $this.val();

    if ($this.length > 0) {
      cartJSRemoveQuery($key, false);
      $(document).on('cart.requestComplete', function(event, cart) {
        location.reload();
      });
    }
  });
}
//End GWP promo

cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) =>{
  var datajson ='{"' + vid + '"' + ':' + '"' + qty + '"}';
  var object = JSON.parse(datajson);

  //var varqty = parseInt(qty);

  CartJS.updateItemById(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          console.log('success',location.pathname);
          getThis.element.dispatchEvent(new CustomEvent('product:added', {
            bubbles: isOpenDrawer,
            detail: {
              variant: vid,
              quantity: 1
            }
          }));
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });




  /*
  jQuery.post('/cart/update.js', {
  updates: object
  })
  .done(function() {
    setTimeout(function(){
      $('.jsc-cart-button').attr("href","/cart");
      if (location.href.includes('/cart')) {
        $('.jsc-check-checkout').val('true');
      }

      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          $('.jsc-number-icon').text(cart.item_count);
          $('.jsc-page-loading').remove();
          console.log('success',location.pathname);
          getThis.element.dispatchEvent(new CustomEvent('product:added', {
            bubbles: isOpenDrawer,
            detail: {
              variant: vid,
              quantity: 1
            }
          }));
        }
      });
    },1200);
  })
  .fail(function() {
    $('.jsc-page-loading').remove();
    console.log( "error" );
  });
  */

}

cartJSRemoveQuery = (vid, isOpenDrawer) =>{
  CartJS.removeItemById(vid,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          console.log('before');
        },
        success: function(cart) {
          console.log('success',location.pathname);
          getThis.element.dispatchEvent(new CustomEvent('product:added', {
            bubbles: isOpenDrawer,
            detail: {
              variant: vid,
              quantity: 0
            }
          }));
        }
      });
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

//Start onload and onclick all promo
masterPromo = (isDrawer) =>{
  disabletocar();
  carticonNum();
  setTimeout(function(){
    addGWP(isDrawer);
    addmultipleGWP(isDrawer);
    removeGWP();
    removemultipleGWP();
    addTier(isDrawer);
    updatePwp(isDrawer);
    addcombinationTier(isDrawer);
  },1500);
}
reloadcart = () =>{
  $(document).on('cart.requestComplete', function(event, cart) {
    location.reload();
  });
  setTimeout(function(){
    location.reload();
  },1500);
}

carticonNum = () =>{
  $(document).on('cart.requestComplete', function(event, cart) {
    $.when($.getJSON('/cart.js', function(cart) {
       $totalcartqty = cart.item_count;
    })).then(function(){
      var iconclass = $('.jsc-number-icon');
      iconclass.text($totalcartqty)
    });
  });
}

disabletocar = () =>{
 var $ele1 = $('.jsc-hidden-add-gwp');
 var $ele2 = $('.jsc-hidden-add-multiple-gwp');
 var $ele3 = $('.jsc-remove-gwp');
 var $ele4 = $('.jsc-remove-multiple-gwp');
 var $ele5 = $('.jsc-tier');
 var $ele6 = $('.jsc-pwp-update');
 var $ele7 = $('.jsc-combi-tier');

 if ( $ele1.length > 0 || $ele2.length > 0 || $ele3.length > 0 || $ele4.length > 0 || $ele5.length > 0 || $ele6.length > 0 || $ele7.length > 0 ) {
   $('.jsc-cart-button').attr("href","#");
   if (location.href.includes('/cart')) {
     $('.jsc-check-checkout').val('false');
   }
     var $html = `<div class="jsc-page-loading">
                   <div class="jsc-spinner-container">
                     <div class="jsc-spinner"></div>
                   </div>
                 </div>`;
     $('body').prepend($html);


   $(document).on('cart.requestComplete', function(event, cart) {
     $('.jsc-cart-button').attr("href","/cart");
     if (location.href.includes('/cart')) {
       $('.jsc-check-checkout').val('true');
     }
   });
 }else {
   $(document).on('cart.requestStarted', function(event, cart) {
     var $html = `<div class="jsc-page-loading">
                   <div class="jsc-spinner-container">
                     <div class="jsc-spinner"></div>
                   </div>
                 </div>`;
     $('body').prepend($html);
   });
 }
}
//End onload and onclick all promo

//Start tier promo

clicktierOption = (evt) =>{
  $('.jsc-tier-option').removeClass( "selectedSubprod" );
  $(evt).toggleClass( "selectedSubprod" );

  if ( $('.selectedSubprod').length > 0 ) {
    var _atcButton = $('.jsc-multiple-atc');
    _atcButton.show();
    _atcButton.removeAttr('disabled');
  }else {
    var _atcButton = $('.jsc-multiple-atc');
    _atcButton.hide();
    _atcButton.attr('disabled');
  }

}
atcTierPDP = (evt) =>{
  var vid = $(evt).attr('data-id');
  var qty = $('.jsc-tier-option.selectedSubprod').attr('data-qty');
  var obj = {};

  $(document).on('cart.requestComplete', function(event, cart) {
    location.reload();
  });

  cartJSAddQuery(null, vid, qty, obj, false , true);

}

clickopenpopuptier = () =>{
  $('.jsc-table-tier').show();
}
clickclosepopuptier = () =>{
  $('.jsc-table-tier').hide();
}

addTier = (isDrawer) =>{
  var $ele = $('.jsc-tier');

  $ele.each(function(){
    var $obj = {};
    var $this = $(this);
    var $key = $this.attr('data-key');
    var $discountVal = $this.val();
    var $discountType = $this.attr('data-discount');
    var $tierNo = $this.attr('data-tier');
    var $qty = $this.attr('data-qty');
    var $promocode = $this.attr('data-promo-code');

    if ($discountVal == '0') {
      $obj['_Tier'] = 'Removed';
    }else{
      $obj['_Quantity-Promo'] = $discountType;
      $obj['_Off-Value'] = $discountVal;
      $obj['_Tier'] = $tierNo;
      $obj['_Promo-Code'] = $promocode;
      console.log("tiersuccess");
    }

    cartJSUpdateQuery($key, $qty, $obj, isDrawer);
  });
}
//End tier promo

//Start combination tier promo
addcombinationTier = (isDrawer) =>{
  var $ele = $('.jsc-combi-tier');

  $ele.each(function(){
    var $obj = {};
    var $this = $(this);
    var $key = $this.attr('data-key');
    var $discountVal = $this.val();
    var $discountType = $this.attr('data-discount');
    var $tierNo = $this.attr('data-tier');
    var $qty = $this.attr('data-qty');
    var $promocode = $this.attr('data-promo-code');

    if ($discountVal == '0') {
      $obj['_Tier'] = 'Removed';
    }else{
      $obj['_Quantity-Promo'] = $discountType;
      $obj['_Off-Value'] = $discountVal;
      $obj['_Tier'] = $tierNo;
      $obj['_Promo-Code'] = $promocode;
    }

    cartJSUpdateQuery($key, $qty, $obj, isDrawer);
  });
}
combinationTierATC = (isDrawer) =>{
  var $ele = $('.jsc-combi-atc-tier');

  $ele.each(function(){
    var $obj = {};
    var $this = $(this);
    var $key = $this.attr('data-key');
    var $discountVal = $this.val();
    var $discountType = $this.attr('data-discount');
    var $tierNo = $this.attr('data-tier');
    var $qty = $this.attr('data-qty');
    var $promocode = $this.attr('data-promo-code');

    if ($discountVal == '0') {
      $obj['_Tier'] = 'Removed';
    }else{
      $obj['_Quantity-Promo'] = $discountType;
      $obj['_Off-Value'] = $discountVal;
      $obj['_Tier'] = $tierNo;
      $obj['_Promo-Code'] = $promocode;
    }
    console.log($key);
    console.log($qty);
    console.log($obj);
    cartJSAddQuery(null, $key, $qty, $obj, isDrawer, null);
    $(document).on('cart.requestComplete', function(event, cart) {
      location.reload();
    });
  });
}
//End combination tier promo

//Start saleforce promo
applySalesForce = (isDrawer) =>{
  var $inputField = $('.jsc-sales_force');

  $inputField.each(function(){
    var $this = $(this);
    var $discountVal = $this.val();
    var $message = $this.attr('data-msg');
    var $key = $this.attr('data-key');
    var $qty = $this.attr('data-qty');
    var $_customerTag = $this.attr('data-tag');
    // Get previous line item properties and assign them
    var $property = $this.attr('data-properties');
    var $object = $.parseJSON($property);

    $object['_sales-value-off'] = $discountVal;
    $object['_Message'] = $message;
    $object['_Sales-Force'] = 'true';
    $object['_Customer-tag'] = $_customerTag;

    cartJSUpdateQuery($key, $qty, $object, isDrawer );
  });
}

removeSalesForce = () =>{
  var $inputField = $('.jsc-remove_sales_force');

  $inputField.each(function(){
    var $this = $(this);
    var $key = $this.attr('data-key');
    var $qty = $this.attr('data-qty');
    // Get previous line item properties and assign them
    var $property = $this.attr('data-properties');
    var $object = $.parseJSON($property);

    CartJS.updateItemById($key, $qty, $object);
  });
  if ($inputField.length > 0) {
    $(document).on('cart.requestComplete', function(event, cart) {
      location.reload();
    });
  }
}
//End saleforce promo

//Start multiple GWP
addmultipleGWP = (isOpenDrawer) =>{
  $.when($.getJSON('/cart.js', function(cart) {

  })).then(function(cart){
    var $gwpcart_product = {};
    var $ele = $('.jsc-hidden-add-multiple-gwp');
    var $promoArray = [];

    // if there are GWP product properties then get the promo number
    for (var i = 0; i < cart.items.length; i++) {
      var $promo = cart.items[i].properties._GWP_Multiple_Promo;
      if ($promo != undefined) {
        $promoArray.push($promo);
      }
    }

    $ele.each(function() {
      var $vid = parseInt($(this).val());
      var $promoNo = $(this).attr('data-promo');
      var $gwppromoCode = $(this).attr('data-promo-code');
      var $qty = parseInt($(this).attr('data-qty'));
      $gwpcart_product['_GWP_Multiple_Promo'] = $promoNo;
      $gwpcart_product['_GWP'] = "true";
      $gwpcart_product['_GWP_Multiple_Promo_Code'] = $gwppromoCode;

      if ($(this).length > 0) {
        if ($promoArray.includes($promoNo)) {
          // if initially is in cart then Update
          cartJSUpdateQuery($vid,$qty,$gwpcart_product, isOpenDrawer);
        } else {
          // if initially not in cart then Add
          cartJSAddQuery(null, $vid, $qty, $gwpcart_product, isOpenDrawer , null);
        }
      }
    });
  });
}
removemultipleGWP = () =>{
  var $ele = $('.jsc-remove-multiple-gwp');

  $ele.each(function(){
    var $this = $(this);
    var $key = $this.val();

    if ($this.length > 0) {
      cartJSRemoveQuery($key, false);
      $(document).on('cart.requestComplete', function(event, cart) {
        location.reload();
      });
    }
  });
}
//End multiple GWP

//Start fake checkout button click
checkoutClick = (evt) =>{
  var $this = $(evt);
  var checkCart = $('.jsc-check-checkout').val();
  var $ele1 = $('.jsc-hidden-add-gwp');
  var $ele2 = $('.jsc-hidden-add-multiple-gwp');
  var $ele3 = $('.jsc-remove-gwp');
  var $ele4 = $('.jsc-remove-multiple-gwp');
  var $ele5 = $('.jsc-tier');
  var $ele6 = $('.jsc-pwp-update');
  var $ele7 = $('.jsc-combi-tier');

    $this.attr('disabled', true);
    //applySalesForce();
    masterPromo(false);

  if ($('.isCartJS').length > 0 || $('.jsc-sales_force').length > 0 || $ele1.length > 0 || $ele2.length > 0 || $ele3.length > 0 || $ele4.length > 0 || $ele5.length > 0 || $ele6.length > 0 || $ele7.length > 0) {
    console.log('checkout');
    $(document).on('cart.requestComplete', function(event, cart) {
        $('#originalcheckout').click();
    });
  } else {
    console.log('default click');
    $('#originalcheckout').click();
  }

}
//End fake checkout button click

//loading img when cartjs run
cartJsEvent = () =>{
  /*$(document).on('cart.requestStarted', function(event, cart) {
    var $html = `<div class="jsc-page-loading">
                  <div class="jsc-spinner-container">
                    <div class="jsc-spinner"></div>
                  </div>
                </div>`;
    $('body').prepend($html);
  });*/
  $(document).on('cart.requestComplete', function(event, cart) {
    $('.jsc-page-loading').remove();
  });
}


//start of pwp function
promotionVariantSelector = (evt, productType, index) =>{
  var $this = $(evt);
  var $selectedOption = $this.find('option:selected');
  var $parent = $this.parent();
  var $val = $this.val();
  var $imgUrl = $selectedOption.attr('data-img');
  var $type = $selectedOption.attr('data-type');
  var $amount = parseInt($selectedOption.attr('data-amount'));
  var $price = parseFloat($selectedOption.attr('data-price'));
  var $comparePrice = parseFloat($selectedOption.attr('data-compare-price')).toFixed(2);
  var $vID = $selectedOption.attr('data-vid');

  // Change variant image
  $parent.find('.jsc-promo--img').attr('src', 'https:'+$imgUrl ).attr('alt', $val);

  // Change variant price
  if (productType == 'normal') {
    // change price for normal product or the product that does not apply discount from theme settings
    $parent.find('.jsc-promo--pricelist').find('.jsc-promo--normal-price').text('$'+$comparePrice);
    $parent.find('.jsc-promo--pricelist').find('.jsc-promo--discounted-price').text('$'+$price);
  } else if (productType == 'discount') {
    // change price for discount product or the product that apply discount from theme settings
    if ($amount > 0) {
      if ($type == 'percentage-off') {
        var $dec = $amount / 100.0;
        var $minusVal = $price * $dec;
        var $finalPrice = $price - $minusVal;

        $parent.find('.jsc-promo--pricelist').find('.jsc-promo--normal-price').text('$'+$price);
        $parent.find('.jsc-promo--pricelist').find('.jsc-promo--discounted-price').text('$'+$finalPrice.toFixed(2));
      } else if ($type == 'price-off') {
        var $dec = $amount / 100.0;
        var $finalPrice = $price - $dec;

        $parent.find('.jsc-promo--pricelist').find('.jsc-promo--normal-price').text('$'+$price);
        $parent.find('.jsc-promo--pricelist').find('.jsc-promo--discounted-price').text('$'+$finalPrice.toFixed(2));
      }
    }
  }

  // Update the ATC btn with the selected variant id
  $('.jsc-promo--atc-btn').attr('data-item-'+index, $vID);
}

addPwp = (evt) =>{
  var $mainObj = {}, $secObj = {};
  var $this = $(evt);
  var $product1 = parseInt($this.attr('data-item-1'));
  var $product2 = parseInt($this.attr('data-item-2'));
  var $setlimit = parseInt($this.attr('data-limit'));
  var $type = $this.attr('data-discount-type');
  var $amount = $this.attr('data-discount-amount');
  var $promo = $this.attr('data-promo');
  var $promoCode = $this.attr('data-promo-code');
  var $bindID = $promo+'-'+$product1 +'-'+$product2;
  var _totalcurrent = 0;
  var _limitContainer = $('.jsc-limit-container');
  var _atcButton = $('.jsc-promo--atc-btn');
  var _button = $this.attr('data-button');

  $secObj['_Quantity-Promo'] = $type;
  $secObj['_Off-Value'] = $amount;
  $secObj['_BindID'] = $bindID;
  $secObj['_PWP'] = 'Second';
  $secObj['_Limit'] = $setlimit;
  $secObj['_Promo-Code'] = $promoCode;

  $mainObj['_BindID'] = $bindID;
  $mainObj['_PWP'] = 'Main';
  $mainObj['_Limit'] = $setlimit;
  $mainObj['_Promo-Code'] = $promoCode;

  $.when($.getJSON('/cart.js', function(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].properties['_BindID'] == $bindID && cart.items[i].properties['_PWP'] == 'Second') {
        console.log('check qty pwp sec');
        console.log(cart.items[i].quantity);
        _totalcurrent = cart.items[i].quantity + 1;
        console.log(_totalcurrent);
      }
    }

  })).then(function(cart){
  if (_totalcurrent > $setlimit && $setlimit != 0) {
    console.log('limit reach');
    _limitContainer.show();
    _atcButton.hide();
    _atcButton.attr('disabled', true);

  }else {
    console.log('limit not reach');
    console.log(_totalcurrent);
    console.log();
    _limitContainer.hide();
    _atcButton.show();
    _atcButton.attr('disabled', false);
    cartJSAddQuery(null, $product1, 1, $mainObj, false, null);
    cartJSAddQuery(null, $product2, 1, $secObj, false, null);
    if (_totalcurrent == $setlimit && $setlimit != 0 ) {
      _limitContainer.show();
      _atcButton.hide();
      _atcButton.attr('disabled', true);
    }
    if ($setlimit == 1 ) {
      _limitContainer.show();
      _atcButton.hide();
      _atcButton.attr('disabled', true);
    }
    $(document).on('cart.requestComplete', function(event, cart) {
      if (_button == 'atc') {
        location.reload();
      }
      if (_button == 'buy') {
        window.location.href = "/checkout/";
      }
    });
  }
  });
}

removePwp = (evt) =>{
  var $this = $(evt);
  var $bindID = $this.attr('data-bind-id');
  var $keys = '';
  $.when($.getJSON('/cart.js', function(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].properties['_BindID'] == $bindID && cart.items[i].properties['_PWP'] == 'Second') {
        $keys += cart.items[i].key + ",";
      }
    }
  })).then(function(cart){
    var $keyArray = $keys.split(',');

    for (var i = 0; i < $keyArray.length; i++) {
      if ($keyArray[i] != '') {
        cartJSRemoveQuery($keyArray[i], false);
        $(document).on('cart.requestComplete', function(event, cart) {
          location.reload();
        });
      }
    }
  });
}

updatePwp = (isDrawer) =>{
  var $ele = $('.jsc-pwp-update');

  if ($ele.length > 0) {
    $ele.each(function(){
      var $this = $(this);
      var $key = $this.val();
      var $qty = parseInt($this.attr('data-qty'));
      var $dataLimit;
      var $obj = {};

      $.when($.getJSON('/cart.js', function(cart) {
        // get the line iteem properties
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key == $key && cart.items[i].properties['_PWP'] == 'Second') {
            $obj = cart.items[i].properties;
            $dataLimit = parseInt(cart.items[i].properties['_Limit']);
          }
        }
      })).then(function(cart){
        // update pwp qty
        cartJSUpdateQuery($key, $qty, $obj, isDrawer);
        if ($dataLimit != 0) {
        $(document).on('cart.requestComplete', function(event, cart) {
          location.reload();
        });
        }
      });
    });
  }
}

changePWPquantity = (evt) =>{
  setTimeout(function(){
      location.reload();
  },2100);
}
//End of pwp function

//Start open close tab account page
changetabs = (evt) =>{
  var $this = $('.jsc-menu-tabs');
  var dataTabs = $(evt).attr('data-tabs');

  $this.each(function(){
    var $dataTabs = $(this).attr('data-tabs');

      if ($dataTabs == dataTabs) {
        $(this).addClass('isactive');
      }else {
        $(this).removeClass('isactive');
      }
   });

   if (dataTabs == "order-history") {
     $('.jsc-order-content').show();
     $('.jsc-personal-content').hide();
   }
   if (dataTabs == "personal-info") {
     $('.jsc-order-content').hide();
     $('.jsc-personal-content').show();
   }

}

//End open close tab account page

copyLink = (element) =>{
  var $temp = $("<input>");
  var $share = $(".jsc-Product__ShareItem");
  $("body").append($temp);
  $temp.val($(element).text()).select();
  document.execCommand("copy");
  $share.text('복사완료!');
  setTimeout(function(){
    $share.text('링크복사');
  },1000);
  $temp.remove();
}

entersearch = (element) =>{
  $('input.jsc-search-enter').on("keypress", function(e) {
            /* ENTER PRESSED*/
            if (e.keyCode == 13) {
              event.preventDefault();
              $('.jsc-view-all')[0].click();
            }
  });
}

zoomimgdesbelow = (evt) =>{
  if ($(window).width() < 481) {

  var _imgscr = $(evt).attr('src');
  var _zoomcontainer = $('.jsc-zoom-img');
  _zoomcontainer.children().remove();
  _zoomcontainer.append('<img alt="" src='+_imgscr+'>')
  $('.jsc-zoom-description-below').show();
  $('.jsc-RoundButton').show();
  }
}
closezoomimgdesbelow = () =>{
  $('.jsc-zoom-description-below').hide();
  $('.jsc-RoundButton').hide();
}

// start promo multiple purchase option
clickopenpopupoption = () =>{
  $('.mulpur-popup').show();
  $('.jsc-multiple-atc').addClass('open-mulpur-popup');
}
clickclosepopupoption = () =>{
  $('.mulpur-popup').hide();
  $('.jsc-multiple-atc').removeClass('open-mulpur-popup');
}
clicksubproductoption = (evt,dataID) =>{
  $(evt).toggleClass( "selectedSubprod" );

  /*var _subprodoption = $('.mulpur-subprod-button');

  _subprodoption.each(function(){
    var $this = $(this);
    var $productID = $this.attr('data-product-id');

    if ($productID == dataID ) {
      $this.addClass('selectedSubprod');
    }else {
      $this.removeClass('selectedSubprod');
    }

  });*/

  if ( $('.selectedSubprod').length > 0 && $('.selectedMainprod').length > 0 ) {
    var _atcButton = $('.jsc-multiple-atc');
    _atcButton.show();
    _atcButton.removeAttr('disabled');
  }else {
    var _atcButton = $('.jsc-multiple-atc');
    _atcButton.hide();
    _atcButton.attr('disabled');
  }

}
atcmultiplepurchaseoption = () =>{
  var _mainprodclass = $('.selectedMainprod');
  var _discountType = _mainprodclass.attr('data-discount');
  var _promocode = _mainprodclass.attr('data-promo-code');
  var _maindiscountVal = _mainprodclass.attr('data-discount-value');
  var _mainqID = parseInt(_mainprodclass.attr('data-product-id'));
  var _mainqty = parseInt(_mainprodclass.attr('data-qty'));
  var _promo = _mainprodclass.attr('data-promo');
  var _maintitle = _mainprodclass.attr('data-title');

  var _subprodclass = $('.selectedSubprod');

  _subprodclass.each(function(){
    var _mainobj = {};

    var _subnobj = {};
    var _subdiscountVal = $(this).attr('data-discount-value');
    var _subtitle = $(this).attr('data-title');
    var _subqID = parseInt($(this).attr('data-product-id'));
    var _subqty = parseInt($(this).attr('data-qty'));
    var _promoLabel = '묶음상품: '+_maintitle+' x '+_subtitle;

    var _bindID = _promo+'-'+_mainqID+'-'+_subqID;

      _mainobj['_Quantity-Promo'] = _discountType;
      _mainobj['_Off-Value'] = _maindiscountVal;
      _mainobj['_BindID'] = _bindID;
      _mainobj['_MultipleOption'] = 'Main Product';
      _mainobj['_Main-Quantity'] = _mainqty;
      _mainobj['_Promo-Code'] = _promocode;
      _mainobj['_Promo-Label'] = _promoLabel;

      _subnobj['_Quantity-Promo'] = _discountType;
      _subnobj['_Off-Value'] = _subdiscountVal;
      _subnobj['_BindID'] = _bindID;
      _subnobj['_MultipleOption'] = 'Sub Product';
      _subnobj['_Main-Quantity'] = _subqty;
      _subnobj['_Promo-Code'] = _promocode;
      _subnobj['_Promo-Label'] = _promoLabel;

     cartJSAddQuery(null, _mainqID, _mainqty, _mainobj, false, null);
     cartJSAddQuery(null, _subqID, _subqty, _subnobj, false, null);

  });

  $(document).on('cart.requestComplete', function(event, cart) {
     location.reload();
  });

}

plusminusmultipleoption = (evt,number) =>{
  var currentclass = $( evt ).siblings( ".QuantitySelector__CurrentQuantity" );
  var currentVal = parseInt(currentclass.val());
  var currentupdateval = parseInt(currentVal + number);
  var updateVal = parseInt(currentupdateval);
  // NProgress.start();
  var _cart;
  var _bundleid = $(evt).attr('data-bind-id');


  if (updateVal > 0) {

    // Call cart json
     $.getJSON('/cart.js', function(cart) {
       _cart = cart;

       // Remove addon item
       for (var i = 0; i < _cart.items.length; i++) {

         //console.log(cart.items[i].properties['_BindID']);
         if (cart.items[i].properties['_BindID'] == _bundleid && cart.items[i].properties['_MultipleOption'] == 'Sub Product') {
           var _currentoptionqty = parseInt(cart.items[i].properties['_Main-Quantity']);
           var _finalupdateoptqty = _currentoptionqty * updateVal;
           CartJS.updateItemById(cart.items[i].key, _finalupdateoptqty);
         }
         if (cart.items[i].properties['_BindID'] == _bundleid && cart.items[i].properties['_MultipleOption'] == 'Main Product') {
           var _currentoptionqty = parseInt(cart.items[i].properties['_Main-Quantity']);
           var _finalupdateoptqty = _currentoptionqty * updateVal;
           CartJS.updateItemById(cart.items[i].key, _finalupdateoptqty);
         }
       }
     });

  }else {
    // Call cart json
      $.getJSON('/cart.js', function(cart) {
        _cart = cart;
        console.log('remove item');

        // Remove addon item
        for (var i = 0; i < _cart.items.length; i++) {
          //console.log(cart.items[i].properties['_BindID']);
          if (cart.items[i].properties['_BindID'] == _bundleid && cart.items[i].properties['_MultipleOption'] == 'Sub Product') {
            CartJS.updateItemById(cart.items[i].key, 0);
          }
          if (cart.items[i].properties['_BindID'] == _bundleid && cart.items[i].properties['_MultipleOption'] == 'Main Product') {
            CartJS.updateItemById(cart.items[i].key, 0);
          }
        }
      });
  }

  $(document).on('cart.requestComplete', function(event, cart) {
    location.reload();
  });

}

removemultiplepurchase = (evt) =>{
  // NProgress.start();
  var _cart;
  var _bundleid = $(evt).attr('data-bind-id');

  // Call cart json
    $.getJSON('/cart.js', function(cart) {
      _cart = cart;

      // Remove addon item
      for (var i = 0; i < _cart.items.length; i++) {
        //console.log(cart.items[i].properties['_BindID']);
        if (cart.items[i].properties['_BindID'] == _bundleid && cart.items[i].properties['_MultipleOption'] == 'Sub Product') {
          CartJS.updateItemById(cart.items[i].key, 0);
        }
        if (cart.items[i].properties['_BindID'] == _bundleid && cart.items[i].properties['_MultipleOption'] == 'Main Product') {
          CartJS.updateItemById(cart.items[i].key, 0);
        }
      }
    });

    $(document).on('cart.requestComplete', function(event, cart) {
      location.reload();
   });
}

// end promo multiple purchase option

initbuyitwithflickity = () =>{
    $('.jsc-buyitwith').flickity({
      // options
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      contain: true,
      cellAlign: "center",
      dragThreshold: 8,
      groupCells: true,
      on: {
        ready: function() {
          $(this.element).addClass('jsc-flickity-initiated');
        }
      }
    });
  }

  swapimgclickthumbnail = (mediaID) =>{
    console.log($(window).width());
    if ($(window).width() >= 1120) {
      var _mediaID = mediaID;
      var _imgclass = $('.jsc-product-img');

      _imgclass.each(function(){
        var $this = $(this);
        var $mediaID = $this.attr('data-media-id');

        if ($mediaID == _mediaID) {
          $this.removeClass('jsc-hide');
        }else {
          $this.addClass('jsc-hide');
        }

      });
    }else {
      var _imgclass = $('.jsc-product-img');
      _imgclass.each(function(){
        var $this = $(this);
        $this.removeClass('jsc-hide');
      });
    }
  }
  swapimgclickdot = (mediaID) =>{
    console.log($(window).width());
    if ($(window).width() >= 991) {
      console.log('swap');
      var _mediaID = mediaID;
      var _imgclass = $('.jsc-product-img');

      _imgclass.each(function(){
        var $this = $(this);
        var $mediaID = $this.attr('data-media-id');

        if ($mediaID == _mediaID) {
          $this.removeClass('jsc-hide');
        }else {
          $this.addClass('jsc-hide');
        }

      });
    }else {
      console.log('noswap');
      var _imgclass = $('.jsc-product-img');
      _imgclass.each(function(){
        var $this = $(this);
        $this.removeClass('jsc-hide');
      });
    }
  }

  onloadswapimgclickthumbnail = () =>{
    if ($(window).width() < 991) {
      var _imgclass = $('.jsc-product-img');
      _imgclass.each(function(){
        var $this = $(this);
        $this.removeClass('jsc-hide');
      });
    }
  }

  onloadswapimgclickthumbnailDesk = () =>{
    if ($(window).width() >= 991) {
      var _imgclass = $('.jsc-product-img');
      _imgclass.each(function(){
        var $this = $(this);
        $this.removeClass('jsc-hide');
      });
    }
  }

  // start update href for ref saleforce id

  checkRefParameter = () =>{
    if (window.location.href.indexOf('ref=') > -1) {
      var $url = window.location.href;
      var $code = $url.substr($url.indexOf('ref='));

      localStorage.setItem("referral-code", $code);
    }
  }

  beAMember = () =>{
    var $a = $('.jsc-be_a_member');

    $a.each(function(){
      var $thisA = $(this);
      var $href = $thisA.attr('data-href');

      var $getLocalStorage = localStorage.getItem("referral-code");
      var $parameter = '';
      if ($getLocalStorage !== null) {
        $parameter = '?'+$getLocalStorage;
      }

      if ($parameter == '') {
        $thisA.attr('href', $href);
        console.log('noadded Href');
      } else {
        $thisA.attr('href', $href+$parameter);
        console.log('added Href');
      }
    });
  }

  // end update href for ref saleforce id

  expandsidebarmenu = () =>{
    var sidebarmenu = $('.jsc-Collapsible__Button');

    sidebarmenu.each(function(){
      var $this = $(this);
      $this.attr('aria-expanded','true');
      $this.next().css('height', 'auto');;
    });

  }
